// Any 8-4-4-4-12 hex id: seeded catalog units are not RFC 4122 v1-v5 UUIDs.
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const isGroundedTutorUnitId = value =>
  typeof value === 'string' && UUID.test(value.trim());

export const groundedTutorContextMessage =
  'Open a course lesson before starting the 1:1 tutor.';

export const buildTutorTokenRequest = ({
  mode = 'VOICE',
  session_id,
  teacherName,
  voice_id,
  courseId,
  unitId,
  lessonId,
  lastQuestion,
}) => ({
  mode: String(mode || 'VOICE').toUpperCase(),
  clientRequestId: session_id,
  instructor: teacherName,
  voiceId: voice_id,
  institution: 'quiklearn',
  courseId,
  unitId,
  lessonId: lessonId ?? null,
  conversationSessionId: session_id,
  lastQuestion,
});
